/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Paging {
    class PagingController extends Meevo.Components.CommonClasses.CommonControllerBase {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            "meevo.components.busy.BusyService",
            "$rootScope",
            "$state",
            '$scope',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.plugins.paging.PagingService',
            '$translate'];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: any,
            protected $scope: angular.IScope,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected pagingService: Meevo.Plugins.Paging.PagingService,
            protected $translate: angular.translate.ITranslateService,
            protected $mdDialog: ng.material.IDialogService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
            this.createContext();
        }

        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_EGIFT).then(() => {
                this.busyService.stop();
                this.context = new PagingContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.pagingService);
                super.createContext();
            });
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }
    }

    angular.module('meevo.plugins.paging')
        .controller('meevo.plugins.paging.PagingController', PagingController);
}